module.exports = __webpack_public_path__ + "static/media/icon-coach.000da69a.svg";